// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1YXbu","gfeWrapper":"CalendarEvent_gfeWrapper__plriD"};